export default "__VITE_ASSET__Dr4_yjWX__"